export default __webpack_public_path__ + "static/media/404.44f55a39.svg";